import {jsonMember, jsonObject} from "typedjson";
import * as moment from "moment";

@jsonObject()
export class DxControlPointPattern {

  /**
   * Идентифкатор паттерна цепочки контрольных точек.
   */
  @jsonMember({constructor: Number, isRequired: true})
  chainPatternId: number;

  /**
   * Длительность контрольной точки. Под длительностью КТ(i) понимается временное расстояние, выраженное в количестве часов, между предыдущей КТ(i-1) и текущей КТ(i).
   */
  @jsonMember({constructor: Number, isRequired: true})
  dayPartOfDuration: number;

  /**
   * Длительность контрольной точки. Под длительностью КТ(i) понимается временное расстояние, выраженное в количестве часов, между предыдущей КТ(i-1) и текущей КТ(i).
   */
  @jsonMember({constructor: Number, isRequired: true})
  hourPartOfDuration: number;


  get duration(): string {
    return (moment.duration({
      day: this.dayPartOfDuration,
      hour: this.hourPartOfDuration,
    }) as any).format('M __, d __, h __', {trim: 'both', stopTrim: 'd'});
  }

  /**
   * Идентификатор.
   */
  @jsonMember({constructor: Number, isRequired: true})
  id: number;

  /**
   * Строковый идент контрольной точки.
   */
  @jsonMember({constructor: String, isRequired: true})
  ident: string;

  /**
   * Наименование контрольной точки.
   */
  @jsonMember({constructor: String, isRequired: true})
  name: string;

  /**
   * Порядок.
   */
  @jsonMember({constructor: Number, isRequired: true})
  ord: number;

  /**
   * Идентифкатор паттерна цепочки контрольных точек.
   */
  @jsonMember({constructor: Number, isRequired: false})
  prevId: number;

  /**
   * заполняется после deserialize
   */
  prevName: string;

  /**
   * Окончание преиода действия данного шаблона контрольной точки.
   */
  @jsonMember({constructor: Date, isRequired: true})
  validityPeriodEndDate: Date;

  /**
   * Начало преиода действия данного шаблона контрольной точки.
   */
  @jsonMember({constructor: Date, isRequired: true})
  validityPeriodStartDate: Date;

}
